var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h1',[_vm._v("Creating a Simple Blog Using Vue with Markdown")]),_c('h4',[_vm._v("March 18, 2019")])])}]

export { render, staticRenderFns }